var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_144_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.2 12.39C2.78 12.39 0 9.61 0 6.2C0 2.79 2.78 0 6.2 0C9.62 0 12.39 2.78 12.39 6.2C12.39 9.62 9.61 12.4 6.2 12.4V12.39ZM6.2 1.81C3.78 1.81 1.81 3.78 1.81 6.2C1.81 8.62 3.78 10.58 6.19 10.58C8.6 10.58 10.57 8.61 10.57 6.2C10.57 3.79 8.61 1.81 6.2 1.81Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.69 14.61C13.47 14.61 13.25 14.53 13.08 14.37L9.12996 10.78C8.75996 10.44 8.72996 9.86996 9.06996 9.49996C9.40996 9.12996 9.97996 9.09996 10.35 9.43996L14.3 13.03C14.67 13.37 14.7 13.94 14.36 14.31C14.18 14.51 13.94 14.61 13.69 14.61Z",
    fill: "#8E8E8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.59,
    height: 14.61,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.877efc767d59e3bbc7ce21a7b960601f.svg";
export { ForwardRef as ReactComponent };